module.exports = __webpack_public_path__ + "img/google_calender.39d983c7.png";